module.exports = __webpack_public_path__ + "img/nuclei-04.e0b652fb.png";